import React from "react";
import colors from "theme/config/colors";
import Button, { Theme } from "theme/components/buttons/Button";

const LightGreenSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.black,
        backgroundColor: colors.lightGreen,
        hover: {
            color: colors.lightGreen,
            backgroundColor: "transparent",
            borderColor: colors.lightGreen,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default LightGreenSolidButton;
